import { useMemo, useCallback } from 'react'

import { SelectBox, FieldAddons } from 'devextreme-react/select-box'
import TextBox from 'devextreme-react/text-box'
import DataSource from 'devextreme/data/data_source'

import { useIxTheme, themesList } from 'contexts/theme-context'

import './theme-switcher.scss'
import {useTranslation} from 'react-i18next'

const dataSource = new DataSource({
    store: {
        data: themesList,
        type: 'array',
        key: 'id'
    },
    group: 'category'
})

const ThemeIcon = (data: any) => {
    return (
        <img
            className='themeSwitcher__field__icon'
            src={data && data.imgSrc}
            alt={data && data.name}
        />
    )
}

const Item = (data: any) => {
    return (
        <div className='themeSwitcher__field'>
            <img className='themeSwitcher__field__icon' src={data.imgSrc} alt={data.name} />
            <div className='themeSwitcher__field__name'>{data.name}</div>
        </div>
    )
}

export const Group = (data: any) => {
    const { t } = useTranslation()
    if (data.key === 'light') {
        return (<p>{ t('global:label.lightThemes') }</p>)
    } else if (data.key === 'dark') {
        return <p>{ t('global:label.darkThemes') }</p>
    }
}

export const ThemeSwitcher = () => {
    const theme = useIxTheme()

    const onValueChanged = useCallback((e: any) => {
        if (theme && theme.changeTheme) {
            theme.changeTheme(e.value.dxName)
        }
    }, [theme])

    const val = useMemo(() => {
        return themesList.find(el => el.dxName === theme.currentTheme)
    }, [theme.currentTheme])

    return (
        <SelectBox
            className='themeSwitcher'
            dataSource={dataSource}
            // valueExpr='id'
            displayExpr='name'
            searchEnabled={false}
            grouped={ true }
            onValueChanged={onValueChanged}
            // fieldRender={Field}
            itemRender={Item}
            groupRender={Group}
            style={{marginRight: 10}}
            width={250}
            // defaultValue={defaultValue}
            value={ val }
        >
            <FieldAddons beforeRender={ThemeIcon} />
        </SelectBox>
    )
}
